export default __webpack_public_path__ + "static/media/provesional_restoration_upper_16_4@2x.9b2171ad.png";